import {
    ADD_TO_COMPARISON,
    REMOVE_FROM_COMPARISON,
    CLEAR_COMPARISONS
} from '../../actions/compareActions';

const CompareReducer = (state = [], action) => {
    Object.freeze(state);
    let newState = state.slice();

    switch (action.type) {
        case ADD_TO_COMPARISON:
            const newCompareItem = {};
            newCompareItem[action.result.title] = action.result;

            newState.push(newCompareItem);
            return newState;
        
        case REMOVE_FROM_COMPARISON:
            return newState.filter(item => Object.keys(item)[0] != action.resultTitle);

        case CLEAR_COMPARISONS:
            return [];
    
        default:
            return state;
    }
};

export default CompareReducer;